import SignComponent from '../components/SignComponent'
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SignupPage = () => {
  const token = useSelector((state) => state?.cred?.token);
   

  if (token) return <Navigate to="/" replace />;
  
  return (
    <div>
      <SignComponent signin={false} />
    </div>
  )
}

export default SignupPage